import { renderToStaticMarkup } from 'react-dom/server';

let InsertionTypes = /*#__PURE__*/function (InsertionTypes) {
  InsertionTypes[InsertionTypes["INITIAL"] = 0] = "INITIAL";
  InsertionTypes[InsertionTypes["PREPEND"] = 1] = "PREPEND";
  InsertionTypes[InsertionTypes["APPEND"] = 2] = "APPEND";
  return InsertionTypes;
}({});
function appendRow({
  bodyRef,
  rowData,
  renderRow,
  rowIndex,
  deleteOpposite
}) {
  const body = bodyRef.current;
  if (!body) {
    console.warn("useVirtualizedBody(): Unable to append row to table body, missing reference.");
    return;
  }
  const row = createRow(renderRow, rowData, rowIndex);
  const opposite = body.children[0];
  if (deleteOpposite && opposite) {
    body.removeChild(opposite);
  }
  body.append(row);
}
function prependRow({
  bodyRef,
  rowData,
  renderRow,
  rowIndex,
  deleteOpposite
}) {
  const body = bodyRef.current;
  if (!body) {
    console.warn("useVirtualizedBody(): Unable to prepend row to table body, missing reference.");
    return;
  }
  const row = createRow(renderRow, rowData, rowIndex);
  const opposite = body.children[body.children.length - 1];
  if (deleteOpposite && opposite) {
    body.removeChild(opposite);
  }
  body.prepend(row);
}
function replaceRow({
  bodyRef,
  rowData,
  renderRow,
  rowIndex,
  relativeRowIndex
}) {
  const body = bodyRef.current;
  if (!body) {
    console.warn("useVirtualizedBody(): Unable to replace row in table body, missing reference.");
    return;
  }
  const oldRow = body.children[relativeRowIndex];

  // In case a row hasn't been rendered at this index yet, them simply append
  // it to our table.
  if (!oldRow) {
    appendRow({
      bodyRef,
      rowData,
      renderRow,
      rowIndex
    });
    return;
  }
  const row = createRow(renderRow, rowData, rowIndex);
  body.replaceChild(row, oldRow);
}
function createRow(renderRow, rowData, index) {
  const elm = document.createElement("tr");
  elm.innerHTML = renderToStaticMarkup(renderRow(rowData, elm, index));
  return elm;
}

export { InsertionTypes, appendRow, createRow, prependRow, replaceRow };
//# sourceMappingURL=InsertionMethods.js.map
